import { isNil } from "lodash";
import { CoverageDocument } from "@graphql/api";

export function isCoverageDocument(obj: unknown): obj is CoverageDocument {
  if (isNil(obj)) return false;
  return typeof obj === "object" && "id" in obj && "name" in obj;
}
